module.exports = __webpack_public_path__ + "img/trial4-1.6205ed5f.png";